module.exports = __webpack_public_path__ + "img/Logo_white_border.10daf772.svg";